export default __webpack_public_path__ + "static/summer_containers99-43efcdcf302da573c77cf1020115fd7d.webp";